import React, { FC } from 'react';
import { scale as initialScale } from '@components/frame';
import { ContentUnavailableCentralPart, ContentUnavailableCentralPartProps } from './ContentUnavailableCentralPart';
import UnavailableContent, { UnavailableContentProps } from './UnavailableContent';
import { font as initialFont } from '@styles/fonts';

export interface OperatorPanelNoConnectorProps
  extends Pick<ContentUnavailableCentralPartProps, 'time' | 'CC'>,
    Omit<UnavailableContentProps, 'children' | 'CC'> {}

const OperatorPanelNoConnector: FC<OperatorPanelNoConnectorProps> = ({
  CC,
  machineName,
  isOperator,
  machineStatus,
  time,
  insetTop,
  insetBottom,
  scale = initialScale,
  font = initialFont,
}) => {
  return (
    <UnavailableContent {...{ CC, machineName, machineStatus, isOperator, insetTop, insetBottom, scale, font }}>
      <ContentUnavailableCentralPart
        {...{
          CC,
          iconConfig: { icon: 'noConnectorLarge', width: scale(300), height: scale(220), color: CC('Label/Light/Error') },
          title: 'No Connector',
          text: 'Download the Smart Factory Connector and install this on a Windows PC or Server that is always on',
          time,
          scale,
          font,
        }}
      />
    </UnavailableContent>
  );
};

export default OperatorPanelNoConnector;
